import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as space from '../space'

export const RESOURCE = {
  payload: {
    alias: 'space:reports',
    appAlias: space.RESOURCE.payload.alias,
    description: 'Reports page',
    display: {
      isMain: true,
      position: 2,
    },
    name: 'Reports',
    page: { id: prebuilt.Page.Id.SpaceReports },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
